const t = {
  en: {
    // Nav
    home:"Home", artists:"Artists", gallery:"Gallery", events:"Events & News",
    about:"About", login:"Login", logout:"Log out", join:"Join the Union",
    searchPlaceholder:"Search artists, events…",
    // Hero
    heroEyebrow:"Sudanese Plastic Artists Union",
    heroTitle:"A home for Sudan's visual artists.",
    heroSub:"We bring together painters, sculptors and visual artists across Sudan and the diaspora — to showcase their work, connect with one another, and grow the movement of Sudanese plastic art.",
    heroCta1:"Join the Union", heroCta2:"Explore artists",
    statArtists:"Member artists", statArt:"Sudanese art", statGlobal:"Countries",
    // Sections
    featuredEyebrow:"From our members", featuredTitle:"Featured artists",
    whyJoin:"Why join", moreThan:"More than a directory",
    seeAll:"See all artists", viewAll:"View all",
    memberCta:"Are you a Sudanese plastic artist?",
    memberCtaTitle:"Add your name to the union.",
    memberCtaSub:"Create your membership profile in minutes — share your story and your art with the world.",
    becomeAMember:"Become a member",
    feature1Title:"Your own artist card",
    feature1Text:"Sign up and an artist profile card is generated automatically with your bio, photo and a gallery of your work.",
    feature2Title:"Connect & belong",
    feature2Text:"Become part of a recognised union of Sudanese plastic artists at home and across the diaspora.",
    feature3Title:"Support & exposure",
    feature3Text:"Promotion, exhibition planning, and links to galleries, funds and opportunities for our members.",
    // Artists page
    ourArtists:"Our Artists", ourArtistsSub:"Meet the members of the Sudanese Plastic Artists Union.",
    searchArtists:"Search by name, specialty, country…",
    noArtists:"No artists found", beFirst:"Be the first to join",
    // Gallery
    galleryTitle:"Gallery", gallerySub:"Original artworks by union members.",
    noGallery:"No artworks yet.", by:"by",
    // Events
    eventsTitle:"Events & News", eventsSub:"Exhibitions, workshops and announcements from the union.",
    allEvents:"All", exhibition:"Exhibition", workshop:"Workshop",
    competition:"Competition", talk:"Talk", festival:"Festival",
    upcoming:"Upcoming", past:"Past",
    // About
    aboutTitle:"About the Union", aboutEyebrow:"Who we are",
    // Search
    searchTitle:"Search Results", searchFor:"Results for",
    noResults:"No results found for", artistResults:"Artists", eventResults:"Events",
    typeToSearch:"Type to search…",
    // Auth
    fullName:"Full name", specialty:"Specialty",
    specialtyPh:"e.g. Painter, Sculptor, Visual Artist",
    email:"Email", password:"Password", passwordHint:"At least 6 characters.",
    country:"Country", telephone:"Telephone", address:"Address", website:"Website",
    shortIntro:"Short intro", introPh:"One or two lines that introduce you as an artist.",
    biography:"Biography", bioPh:"Your full story, training, exhibitions…",
    profilePhoto:"Profile photo", workSamples:"Up to 4 samples of your work",
    submitProfile:"Create my artist card", submitting:"Creating your profile…",
    joinTitle:"Join the Union", joinSub:"Create your membership profile — your artist card is generated automatically.",
    alreadyMember:"Already a member?", signInLink:"Log in",
    welcomeBack:"Welcome back", memberAccess:"Member access",
    signingIn:"Signing in…", signIn:"Log in", newHere:"New here?", joinLink:"Join the union",
    forgotPassword:"Forgot password?", forgotTitle:"Reset your password",
    forgotSub:"Enter your registered email and we'll send you a reset link.",
    sendResetLink:"Send reset link", sending:"Sending…",
    resetSent:"Check your inbox — a reset link is on its way.",
    resetTitle:"Set a new password", newPassword:"New password", confirmPassword:"Confirm password",
    passwordMismatch:"Passwords do not match.", resetSuccess:"Password updated — you can now log in.",
    setPassword:"Set new password", backToLogin:"Back to login",
    resetExpired:"This reset link is invalid or has expired. Please request a new one.",
    // Profile
    viewProfile:"View profile", bio:"Biography", selectedWork:"Selected work", allArtists:"All artists",
    // News
    newsTitle:"News", newsSub:"Latest news from Sudan and the Sudanese art community.",
    artNews:"Art News", artNewsSub:"Latest from the global art world",
    // Register Arabic fields
    shortIntroAr:"Short intro (Arabic)", introArPh:"Write your short intro in Arabic…",
    biographyAr:"Biography (Arabic)", bioArPh:"Write your full biography in Arabic…",
    arFieldsHint:"Arabic fields are optional — they let your profile display correctly for Arabic-speaking visitors.",
    // Footer
    connected:"Get connected with us on our social networks",
    services:"Services", usefulLinks:"Useful links", contact:"Contact",
    // Misc
    loading:"Loading…", darkMode:"Dark mode", newsError:"Could not load feed.", retry:"Retry",
    editProfile:"Edit Profile", editProfileSub:"Update your artist information.",
    saveChanges:"Save Changes", profileUpdated:"Profile updated successfully.",
    photoRequired:"Profile photo is required.", photoHint:"Upload a clear personal profile photo.",
    worksRequired:"At least 3 artworks are required.", worksHint:"Upload at least 3 artworks for your card to appear on the Artists page.",
    introRequired:"Short intro is required.", bioRequired:"Biography is required.",
    mediaPress:{ title:"Artists Media & Press", subtitle:"Videos, interviews, exhibitions and workshops" },
    // Dashboard
    dashLoading:"Loading your dashboard…",
    dashLoadErr:"Could not load your profile.",
    dashGoHome:"Go Home",
    dashViewProfile:"View my profile",
    dashEditProfile:"Edit profile",
    dashCancelEdit:"Cancel",
    dashSignOut:"Sign out",
    dashArtworks:"Artworks",
    dashLocation:"Location",
    dashSpecialty:"Specialty",
    dashEmail:"Email",
    dashEditTitle:"Edit profile",
    dashFullName:"Full name",
    dashCountry:"Country",
    dashAddress:"Address / City",
    dashPhone:"Phone",
    dashWebsite:"Website",
    dashInstagram:"Instagram handle",
    dashFacebook:"Facebook URL",
    dashShortIntro:"Short introduction",
    dashFullBio:"Full biography",
    dashSave:"Save changes",
    dashSaving:"Saving…",
    dashCancel:"Cancel",
    dashAbout:"About",
    dashContactLinks:"Contact & links",
    dashPortfolio:"My portfolio",
    dashSaved:"Profile updated successfully!",
    dashSaveErr:"Failed to save changes.",
    dashMyDashboard:"My Dashboard",
    dashManagePhotos:"Manage photos",
    // Invited / pending members section
    invitedEyebrow:"New members", invitedTitle:"Pending members",
    invitedSub:"These artists have been invited to join the union. Their full profiles will appear here once they complete their details.",
    invitedBadge:"Setting up profile",
  },
  ar: {
    // Nav
    home:"الرئيسية", artists:"الفنانون", gallery:"المعرض", events:"الفعاليات والأخبار",
    about:"عن الاتحاد", login:"تسجيل الدخول", logout:"تسجيل الخروج", join:"انضم للاتحاد",
    searchPlaceholder:"ابحث عن فنانين وفعاليات…",
    // Hero
    heroEyebrow:"الاتحاد العام للفنانين التشكيليين السودانيين",
    heroTitle:"بيت الفنانين التشكيليين السودانيين.",
    heroSub:"نجمع الرسامين والنحاتين والفنانين التشكيليين في السودان وفي الشتات — لعرض أعمالهم، والتواصل مع بعضهم البعض، وتنمية حركة الفن التشكيلي السوداني.",
    heroCta1:"انضم للاتحاد", heroCta2:"استعرض الفنانين",
    statArtists:"فنان عضو", statArt:"فن سوداني أصيل", statGlobal:"دول",
    // Sections
    featuredEyebrow:"من أعضائنا", featuredTitle:"فنانون مميزون",
    whyJoin:"لماذا تنضم", moreThan:"أكثر من مجرد دليل",
    seeAll:"عرض جميع الفنانين", viewAll:"عرض الكل",
    memberCta:"هل أنت فنان تشكيلي سوداني؟",
    memberCtaTitle:"أضف اسمك إلى الاتحاد.",
    memberCtaSub:"أنشئ ملفك الشخصي في دقائق — شارك قصتك وفنك مع العالم.",
    becomeAMember:"كن عضواً",
    feature1Title:"بطاقة الفنان الخاصة بك",
    feature1Text:"سجّل وسيتم إنشاء بطاقة ملفك الشخصي تلقائياً بسيرتك الذاتية وصورتك ومعرض أعمالك.",
    feature2Title:"تواصل وانتمِ",
    feature2Text:"كن جزءاً من اتحاد معترف به يضم الفنانين التشكيليين السودانيين في الوطن والمهجر.",
    feature3Title:"دعم وانتشار",
    feature3Text:"ترويج وتخطيط معارض وروابط بالمتاحف والصناديق والفرص لأعضائنا.",
    // Artists page
    ourArtists:"فنانونا", ourArtistsSub:"تعرّف على أعضاء الاتحاد العام للفنانين التشكيليين السودانيين.",
    searchArtists:"ابحث بالاسم، التخصص، البلد…",
    noArtists:"لا يوجد فنانون", beFirst:"كن أول من ينضم",
    // Gallery
    galleryTitle:"المعرض", gallerySub:"أعمال فنية أصيلة لأعضاء الاتحاد.",
    noGallery:"لا توجد أعمال فنية بعد.", by:"للفنان",
    // Events
    eventsTitle:"الفعاليات والأخبار", eventsSub:"المعارض والورش والإعلانات من الاتحاد.",
    allEvents:"الكل", exhibition:"معرض", workshop:"ورشة عمل",
    competition:"مسابقة", talk:"محاضرة", festival:"مهرجان",
    upcoming:"قادمة", past:"سابقة",
    // About
    aboutTitle:"عن الاتحاد", aboutEyebrow:"من نحن",
    // Search
    searchTitle:"نتائج البحث", searchFor:"نتائج البحث عن",
    noResults:"لا توجد نتائج لـ", artistResults:"الفنانون", eventResults:"الفعاليات",
    typeToSearch:"اكتب للبحث…",
    // Auth
    fullName:"الاسم الكامل", specialty:"التخصص",
    specialtyPh:"مثال: رسام، نحات، فنان بصري",
    email:"البريد الإلكتروني", password:"كلمة المرور", passwordHint:"٦ أحرف على الأقل.",
    country:"البلد", telephone:"الهاتف", address:"العنوان", website:"الموقع الإلكتروني",
    shortIntro:"نبذة قصيرة", introPh:"سطر أو سطران يعرّفانك كفنان.",
    biography:"السيرة الذاتية", bioPh:"قصتك الكاملة، تدريبك، معارضك…",
    profilePhoto:"صورة الملف الشخصي", workSamples:"حتى ٤ نماذج من أعمالك",
    submitProfile:"أنشئ بطاقة الفنان", submitting:"جارٍ إنشاء ملفك الشخصي…",
    joinTitle:"انضم للاتحاد", joinSub:"أنشئ ملفك الشخصي — سيتم إنشاء بطاقة الفنان تلقائياً.",
    alreadyMember:"عضو بالفعل؟", signInLink:"تسجيل الدخول",
    welcomeBack:"مرحباً بعودتك", memberAccess:"وصول الأعضاء",
    signingIn:"جارٍ تسجيل الدخول…", signIn:"تسجيل الدخول", newHere:"جديد هنا؟", joinLink:"انضم للاتحاد",
    forgotPassword:"نسيت كلمة المرور؟", forgotTitle:"إعادة تعيين كلمة المرور",
    forgotSub:"أدخل بريدك الإلكتروني المسجل وسنرسل لك رابط إعادة التعيين.",
    sendResetLink:"إرسال رابط إعادة التعيين", sending:"جارٍ الإرسال…",
    resetSent:"تحقق من بريدك الوارد — رابط إعادة التعيين في طريقه إليك.",
    resetTitle:"تعيين كلمة مرور جديدة", newPassword:"كلمة المرور الجديدة", confirmPassword:"تأكيد كلمة المرور",
    passwordMismatch:"كلمتا المرور غير متطابقتين.", resetSuccess:"تم تحديث كلمة المرور — يمكنك تسجيل الدخول الآن.",
    setPassword:"تعيين كلمة مرور جديدة", backToLogin:"العودة إلى تسجيل الدخول",
    resetExpired:"رابط إعادة التعيين غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.",
    // Profile
    viewProfile:"عرض الملف الشخصي", bio:"السيرة الذاتية", selectedWork:"أعمال مختارة", allArtists:"جميع الفنانين",
    // News
    newsTitle:"الأخبار", newsSub:"آخر الأخبار من السودان ومجتمع الفن التشكيلي السوداني.",
    artNews:"أخبار الفن", artNewsSub:"آخر أخبار عالم الفن العالمي",
    // Register Arabic fields
    shortIntroAr:"نبذة قصيرة بالعربية", introArPh:"اكتب نبذتك القصيرة بالعربية هنا…",
    biographyAr:"السيرة الذاتية بالعربية", bioArPh:"اكتب سيرتك الذاتية الكاملة بالعربية هنا…",
    arFieldsHint:"الحقول العربية اختيارية — تتيح عرض ملفك الشخصي بشكل صحيح للزوار الناطقين بالعربية.",
    // Footer
    connected:"تابعنا على شبكات التواصل الاجتماعي",
    services:"خدماتنا", usefulLinks:"روابط مفيدة", contact:"اتصل بنا",
    // Misc
    loading:"جارٍ التحميل…", darkMode:"الوضع الداكن", newsError:"تعذّر تحميل المحتوى.", retry:"إعادة المحاولة",
    editProfile:"تعديل الملف الشخصي", editProfileSub:"تحديث بيانات ملفك الفني.",
    saveChanges:"حفظ التغييرات", profileUpdated:"تم تحديث الملف الشخصي بنجاح.",
    photoRequired:"الصورة الشخصية مطلوبة.", photoHint:"ارفع صورة شخصية واضحة.",
    worksRequired:"مطلوب رفع 3 صور فنية على الأقل.", worksHint:"ارفع 3 صور فنية على الأقل لتظهر بطاقتك في صفحة الفنانين.",
    introRequired:"النبذة القصيرة مطلوبة.", bioRequired:"السيرة الذاتية مطلوبة.",
    mediaPress:{ title:"الإعلام والصحافة", subtitle:"مقاطع فيديو، مقابلات، معارض وورش عمل" },
    // لوحة التحكم
    dashLoading:"جاري تحميل لوحة التحكم…",
    dashLoadErr:"تعذّر تحميل ملفك الشخصي.",
    dashGoHome:"الصفحة الرئيسية",
    dashViewProfile:"عرض ملفي الشخصي",
    dashEditProfile:"تعديل الملف الشخصي",
    dashCancelEdit:"إلغاء",
    dashSignOut:"تسجيل الخروج",
    dashArtworks:"الأعمال الفنية",
    dashLocation:"الموقع",
    dashSpecialty:"التخصص",
    dashEmail:"البريد الإلكتروني",
    dashEditTitle:"تعديل الملف الشخصي",
    dashFullName:"الاسم الكامل",
    dashCountry:"الدولة",
    dashAddress:"العنوان / المدينة",
    dashPhone:"الهاتف",
    dashWebsite:"الموقع الإلكتروني",
    dashInstagram:"حساب إنستغرام",
    dashFacebook:"رابط فيسبوك",
    dashShortIntro:"نبذة قصيرة",
    dashFullBio:"السيرة الذاتية الكاملة",
    dashSave:"حفظ التغييرات",
    dashSaving:"جارٍ الحفظ…",
    dashCancel:"إلغاء",
    dashAbout:"نبذة عني",
    dashContactLinks:"التواصل والروابط",
    dashPortfolio:"معرض أعمالي",
    dashSaved:"تم تحديث الملف الشخصي بنجاح!",
    dashSaveErr:"فشل حفظ التغييرات.",
    dashMyDashboard:"لوحتي",
    dashManagePhotos:"إدارة الصور",
    // أعضاء مدعوون
    invitedEyebrow:"أعضاء جدد", invitedTitle:"أعضاء في الانتظار",
    invitedSub:"هؤلاء الفنانون تمت دعوتهم للانضمام إلى الاتحاد. ستظهر ملفاتهم الكاملة بعد إكمال بياناتهم.",
    invitedBadge:"قيد الإعداد",
  },
};
export default t;
